import { render, staticRenderFns } from "./wiezijnwij.vue?vue&type=template&id=45c338fa&scoped=true&"
import script from "./wiezijnwij.vue?vue&type=script&lang=ts&"
export * from "./wiezijnwij.vue?vue&type=script&lang=ts&"
import style0 from "./wiezijnwij.vue?vue&type=style&index=0&id=45c338fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c338fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
